<template>
  <div>
    <Header>Услуги</Header>
    <div class="container">
        <div class="row wrapper">
          <section v-if="personalDiscountError"
                   style="padding-top: 15px; padding-bottom: 15px;"
                   class="personal-discount-error col-xl-12 col-12 wrapper-white bottom-border">
            Цены указаны без учета персональных скидок.
            Чтобы увидеть цены с учетом вашей персональной скидки, запишитесь через
            <a href="https://www.myclient.me" target="_blank">приложение MyClient.</a>
          </section>
          <section class="col-xl-12 col-12 wrapper-white bottom-border">
              <!-- SEARCH -->
              <section class="search">
              <div class="search-form">
                  <form action="#" method="GET" v-on:submit="stopSubmitForm($event)">
                  <input
                    v-on:input="searchAction($event, allServices)"
                    type="text"
                    name="search"
                    placeholder="Поиск"
                    autocomplete="off">
                  </form>
              </div>
              </section>
          </section>
          <section class="col-xl-12 col-12 wrapper-white bottom-border">
              <div class="services">
                <ul class="services-information">
                    <li v-for="item in searchList" v-on:click="selectItem($event)" for="info-radio--1" v-bind:key="item.id" class="services-information--item">
                      <div class="information-radio">
                          <label :data-id="item.id"></label>
                          <input id="info-radio--1" type="checkbox" :value="item.id">
                      </div>
                      <div class="service--information">
                          <h4>{{item.title}}</h4>
                          <span class="info--price"><span class="info--price-number">{{ Math.round(item.price) }}</span> <span class="info--price-currency">{{getLocalCurrency(item.currency)}}</span></span>
                          <span class="info--hours">{{item.durationIso}}</span>
                      </div>
                    </li>
                </ul>
              </div>
          </section>
          <section class="col-xl-12 col-12 wrapper-gray">
            <section class="total">
              <span>Всего: <span class="total--cost">0 UAH</span> (<span class="total--time">0 час(ов)</span>)</span>
            </section>
            <section class="buttons">
              <router-link to="/"><button class="btn button-blue">OK</button></router-link>
            </section>
          </section>
        </div>
      </div>
  </div>
</template>

<style>
.total {
  display: none;
  font-family: 'Avenir Next Cyr';
  font-style: normal;
  font-weight: 600;
  font-size: 17px;
  line-height: 134.75%;
  text-align: center;
  margin-top: 2rem;
  text-transform: uppercase;
}

.buttons {
  display: none;
  margin-top: 2rem;
}

label.active {
  background-color: #2F80ED;
  border: 1px solid #fff;
  position: relative;
}

.button-blue {
  padding: 1rem 0px;
  width: 100%;
  text-align: center;
  background: #2F80ED;
  backdrop-filter: blur(81.6395px);
  border: none;
  border-radius: 36px;
  color: #fff;
  margin-bottom: 1rem;
}

.button-blue:active {
  background: #ff9500;
  color: #fff;
}
</style>

<script>

import $ from 'jquery';
import axios from 'axios';
import Header from '../components/header.vue';

export default {
  name: 'Search',
  data() {
    return {
      allServices: [],
      searchList: [],
      searchIndex: null,
      personalDiscountError: false
    };
  },
  metaInfo: {
    title: 'Поиск',
    titleTemplate: '%s - Онлайн-запись MyClient',
    htmlAttrs: {
      lang: 'ru',
      amp: false
    }
  },
  mounted: function() {
    let vm = this;

    switch(APP_MODE) {
      case MODE_PROFESSIONAL:
        getClientsUserStatus(window.professionalId, (clientStatus) => {
          axios.get(`/api/professional/${window.professionalId}/details`).then((response) => {
            const responseData = response.data;
            const data = responseData.data;

            vm.allServices = addServicesDiscounts(data.services, clientStatus);
            vm.searchList = vm.allServices;

            this.selectCurrentElement();
          });
        });
        break;
      case MODE_BOOKING:
        axios.get('/api/auth/check').then((response) => {
          const data = response.data;

          if(data.status === 'error') {
            document.location.href = '/booking/' + window.bookingId + '#/form';
          } else {
            axios.get(`/api/bookings/${window.bookingId}/details`).then((response) => {
              const data = response.data;
              const responseData = data.data;
              getClientsUserStatus(responseData.professional.id, (clientStatus) => {
                window.professionalId = responseData.professional.id;
                this.$store.dispatch('professionalId', responseData.professional.id);

                if (data && data.status) {
                  axios.get(`/api/professional/${window.professionalId}/details`).then((response) => {
                    const responseData = response.data;
                    const data = responseData.data;

                    vm.allServices = addServicesDiscounts(data.services, clientStatus);
                    vm.searchList = vm.allServices;

                    this.selectCurrentElement();
                  });
                } else {
                  this.$router.push('/form');
                }
              });
            });
          }
        });
        break;
      default:
        location.href = '/no-data';
        break;
    }

    function addServicesDiscounts (services, clientStatus) {
      if (!clientStatus) {
        vm.personalDiscountError = true;
      }
      return services.map(it => {
        if (it.discount && (it.discount.clientStatus === 'ALL' || it.discount.clientStatus === clientStatus)) {
          let pricePercent = 100 - it.discount.percent;
          it.price = it.price * pricePercent / 100;
        }
        return it;
      });
    }

    function getClientsUserStatus (professionalId, callback) {
      let phone = (localStorage.getItem('phone') || '').replace(/ /g, '');
      if (phone) {
        axios.get('/api/clients/user', {
          params: {
            professionalId: professionalId,
            phone: phone
          }
        }).then(resp => {
          callback(resp.data && resp.data.data && resp.data.data.status);
        }).catch(() => {
          callback();
        });
      } else {
        callback();
      }
    }
  },
  beforeCreate: function () {
    document.body.className = 'search-page';
  },
  methods: {
    selectItem: function (event) {
      const wrapper = $(event.currentTarget);
      console.log(wrapper);
      const parent = wrapper.find('.information-radio');
      const el = parent.find('label');

      if(el.hasClass('active')) {
        const value = parent.find('input').val();

        this.$store.dispatch('services', {
          keyName: value,
          value: false,
        });

        this.selectCurrentElement();
      } else {
        const value = parent.find('input').val();

        this.$store.dispatch('services', {
          keyName: value,
          value: true,
        });

        this.selectCurrentElement();
      }
    },
    searchAction: function (event, services) {
      const result = [];

      const input = event.currentTarget;
      const value = String(input.value).toLowerCase();

      for(let index in services) {
        const service = services[index];
        const title = String(service.title).toLowerCase();
        if(title.indexOf(value) !== -1) {
          result.push(service);
        }
      }

      this.searchList = result;
      this.unselectAllServices();
      this.selectCurrentElement();
    },
    unselectAllServices: function () {
      for(let key in this.services) {
        this.$store.dispatch('services', {
          keyName: key,
          value: false,
        });
      }
    },
    stopSubmitForm: function (event) {
      event.preventDefault();
    },
    selectCurrentElement: function() {
      setTimeout(() => {
        let checked = false;
        let prices = {};
        let hours = 0;
        let currenct = '';

        for(var key in this.services) {
          let checkselect = this.services[key];
          let label = $(`[data-id="${key}"]`);
          let input = $(`[value="${key}"]`);

          if(checkselect === true) {
            let price = input.parent().parent().find('.info--price-number').text();
            let currenct = input.parent().parent().find('.info--price-currency').text();
            let hour = input.parent().parent().find('.info--hours').text();

            if(hour) {

              hours += Number(this.timestrToSec(hour));
            }
            if(typeof prices[currenct] === 'undefined') {
              prices[currenct] = 0;
            }
            prices[currenct] += Number(price);

            label.addClass('active');

            checked = true;
          } else {
            label.removeClass('active');
          }
        }

        if(checked === true) {
          $('.total').fadeIn(300);
          $('.buttons').fadeIn(300);

          let sum = 0;
          for(let keyPrice in prices) {
              if(typeof prices[keyPrice] !== 'undefined') {
                prices[keyPrice] = Number(prices[keyPrice]);
              } else {
                prices[keyPrice] = 0;
              }

              $('.total--cost').text(prices[keyPrice] + ' ' + String(keyPrice));
              sum = prices[keyPrice];
              currenct = keyPrice;
              break;
          }

          $('.total--time').text(this.formatTime(hours) + ' час(ов)');
          this.$store.dispatch('sum', sum);
          this.$store.dispatch('minutes', hours);
          this.$store.dispatch('hours', this.formatTime(hours));
          this.$store.dispatch('currency', currenct);

        } else {
          $('.total').hide();
          $('.buttons').hide();
        }
      }, 300);
    },
    timestrToSec (timestr) {
      var parts = timestr.split(":");
      return (parts[0] * 3600) +
            (parts[1] * 60);
    },
    pad (num) {
      if(num < 10) {
        return "0" + num;
      } else {
        return "" + num;
      }
    },
    formatTime (seconds) {
      return [this.pad(Math.floor(seconds/3600)),
              this.pad(Math.floor(seconds/60)%60),
              ].join(":");
    },
    getLocalCurrency (curr) {
      return typeof this.currenciesLocal[curr] !== 'undefined'
        ? this.currenciesLocal[curr]
        : curr;
    },
  },
  components: {
    Header
  },
  computed: {
    search () {
      return this.$store.getters.search;
    },
    services () {
      return this.$store.getters.services;
    },
    currenciesLocal () {
      return this.$store.getters.currenciesLocal;
    }
  },
};
</script>
